import { render } from "./ComponentFilaDiretorioArquivo.vue?vue&type=template&id=9a78e578"
import script from "./ComponentFilaDiretorioArquivo.vue?vue&type=script&lang=js"
export * from "./ComponentFilaDiretorioArquivo.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__